import { Eye, File } from 'lucide-react';

interface FileDisplayProps {
  title: string;
  file: { name: string; url: string };
  gradient: string;
  iconColor: string;
}
const FileDisplay = ({ title, file, gradient, iconColor }: FileDisplayProps) => (
  <div>
    <p className="mb-2 text-sm font-semibold text-slate-800">{title}</p>
    <div className={`details-doc-card bg-gradient-to-r ${gradient}`}>
      <div className="flex min-w-0 items-center space-x-3">
        <File className={`h-4 w-4 flex-shrink-0 ${iconColor}`} />
        <span className="details-doc-title">{file.name}</span>
      </div>
      <button
        onClick={() => window.open(file.url, '_blank')}
        className="details-icon-button ml-3 flex-shrink-0 bg-blue-500"
      >
        <Eye className="w-4 h-4" />
      </button>
    </div>
  </div>
);

export default FileDisplay;
